<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      shopId: 'seat/getShopId',
    }),
  },
  watch: {
    shopId(shopId) {
      if (shopId !== null) {
        this.getShopDetail(shopId)
      }
    },
  },
  methods: {
    ...mapActions({
      fetchShopDetail: 'shopDetail/fetchShopDetail',
    }),
    getShopDetail(shopId) {
      this.fetchShopDetail(shopId)
    },
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
